/**
 * DaForge kiadás 2026-09-26 — funkcionális változásnapló + tesztesetek.
 *
 * A tartalom a DaForge-kontraktus JSON-alakja (`DaforgeRelease`), változatlanul;
 * forrás: a `PetykaMaki/kgc-berles` 2026-09-14 → 09-26 közti mergelt PR-jei,
 * kliens-nyelvre összevonva. ÚJ KIADÁS: új fájl ugyanebben az alakban + bejegyzés
 * a `daforge-data.ts` `daforgeReleases` tömbjébe — kódváltozás nem kell.
 */
import type { DaforgeRelease } from '../daforge-data';

export const daforgeRelease20260926: DaforgeRelease = {
  release: {
    id: '2026-09-26',
    title: 'Szervizműhely, PDA, dolgozói súgó és keresőbarát weboldal',
    from: '2026-09-14',
    to: '2026-09-26',
    status: 'tervezet',
  },
  changes: [
    {
      id: 'CH-001',
      prs: [163, 162, 161],
      date: '2026-09-26',
      area: 'Webshop',
      kind: 'Javítás',
      audience: 'ügyfél',
      title: 'Webshop: pontosabb termékadatok és egyedi találati szövegek',
      summary:
        'A Google-találatokban minden webshoptermék saját, egyedi címet és rövid leírást kap a teljes terméknévből és a gyártói cikkszámból — eddig több termékcsoportnál ezek ismétlődtek. Három STIGA terméknél megjelenik a gyártó által igazolt vonalkódszám (EAN), és néhány terméknél (pl. Ceccato SPL13R4H, két Blue Bird tartozék) a „Feltöltés alatt” vagy üres leírás helyett gyártói adatokon alapuló leírás áll. Ár, készlet és a többi termékadat nem változott.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-002',
      prs: [165, 162, 160],
      date: '2026-09-26',
      area: 'Weboldal és keresők',
      kind: 'Változás',
      audience: 'ügyfél',
      title: 'Bérlési katalógus: gyorsabb oldalak, valódi linkek, új útmutatók',
      summary:
        'A bérlési katalógus és a gépoldalak tartalma azonnal betöltődik, a kategóriák és a lapozás valódi linkek, így a Google is látja a teljes kínálatot, a látogató pedig visszalépéskor ugyanott folytatja a listát; minden kategóriaszinten megjelennek az alkategóriák linkjei (eddig a második szinten hiányoztak). Új oldalak: három márkaszerviz-oldal, három bérleti választási útmutató és egy mobilos alkatrész-beazonosító útmutató. A Google a bérgépeknél már nem kap „készleten” jelzést, mert a tényleges elérhetőség a választott bérlési időszaktól függ.',
      uncertain: true,
      note: 'Peti adja meg a három márkaszerviz-oldal, a három választási útmutató és a mobilos alkatrész-beazonosító útmutató pontos címét — a leírás nem nevezi meg őket.',
    },
    {
      id: 'CH-003',
      prs: [169, 166, 164],
      date: '2026-09-26',
      area: 'Weboldal és keresők',
      kind: 'Változás',
      audience: 'ügyfél',
      title: 'Kezdőlap: pontosabb felső sáv, Google-vélemények, kerti linkek',
      summary:
        'Az oldalak tetején futó sáv eddig azt ígérte: „Foglalj online, vidd azonnal”; most ez áll benne: „Bérlési igény online, átvétel visszaigazolás után”, mert a bérlést a pult igazolja vissza. A kezdőlapon a Google-értékelés alatt új „Vélemények a Google-on” link vezet a Kisgépcentrum ellenőrzött Google-profiljára, a kategóriakártyák alatt pedig közvetlen link a Talajmaró bérlése és az Ágdaráló bérlése oldalra.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-004',
      prs: [168, 167],
      date: '2026-09-26',
      area: 'Weboldal és keresők',
      kind: 'Javítás',
      audience: 'ügyfél',
      title: 'Régi Kisgépcentrum-oldalcímek átirányítása az új oldalakra',
      summary:
        'Tizenegy régi, eddig „nem található” hibát adó oldalcím — két jogi oldal, hat régi bérlési kategória (pl. építőipari, kerti, famegmunkáló, mérőeszközök), a betonkeverő, a kisgépszerviz és egy Makita DUC353 bérgép oldala — most automatikusan a megfelelő mai oldalra visz. Aki régi könyvjelzőből vagy régi Google-találatból érkezik, nem hibaoldalt lát.',
      uncertain: true,
      note: 'A teszthez Peti adja meg a 11 régi oldalcím listáját — a leírás nem sorolja fel őket.',
    },
    {
      id: 'CH-005',
      prs: [157, 148, 147],
      date: '2026-09-23',
      area: 'Szerviz',
      kind: 'Új',
      audience: 'ügyfél',
      title: 'Szervizügy követése és árajánlat elfogadása az ügyfélfiókban',
      summary:
        'Az ügyfél a saját fiókjában követheti a szervizügyét, ott fogadhatja el vagy utasíthatja el az árajánlatot, leadáskor pedig teljes javítási keretösszeget adhat meg. A szervizlevelek egyszer használható linket hoznak, amellyel a pultnál vagy telefonon felvett ügyfél is eljut a fiókjáig; az ajánlat-levélben látszik a teljes összeg, a befizetett és a még fizetendő rész és az érvényesség, döntés után visszaigazolás érkezik, a lejárt ajánlat „Lejárt” jelzést kap, a kiadásról pedig levél megy. A szervizoldal mobilon, nagyított betűvel sem lóg ki a képernyőről.',
      uncertain: true,
      note: 'Döntés kell a hangnemről: a szervizlevelek tegeznek, a webes „Szervizbejelentését megkaptuk” visszaigazolás magáz. Peti erősítse meg azt is, hogy az ügyfélfiók élesben be van-e kapcsolva.',
    },
    {
      id: 'CH-006',
      prs: [158, 157, 147],
      date: '2026-09-23',
      area: 'Szerviz',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Szervizmunkalap az átvételtől a kiadásig, új műveletekkel',
      summary:
        'A webes gépleadás és a pultos átvétel ugyanazon a szervizmunkalapon folytatódik a kiadásig: bevizsgálás, becsült és tényleges munkaidő, alkatrészigény, ellenőrzés, nyomtatható A4-es szervizlap és QR-címke, az „átvehető” és a „kiadva” állapot külön. Új műveletek: visszaléptetés indokkal, díjmentes lemondás a bevizsgálás előtt, utólagos befizetés-rögzítés, elérhetőség javítása, garanciális elbírálás és a pulti/telefonos ügyféldöntés rögzítése; az ügyfélfiókban hozott döntésről, a lejáró ajánlatról és a telefonos ügyfélről teendő kerül a „Mai munkám” listába. A napi nézetben látszanak az elmaradt és a visszaigazolandó gépleadások, az ügyfél telefonszámra vagy e-mailre is kereshető, és kiadás előtt a rendszer egyezteti a visszavont vagy meg nem rendelt alkatrészeket.',
      uncertain: true,
      note: 'A leírás szerint a dolgozói felületet böngészőben nem kattintották végig, és több tétel csak címszóként szerepel (pl. „duplikált webes bejelentés”, „holt linkek”, „SLA-határidő”, „késés-szűrő”) — Peti erősítse meg, hol és hogyan jelennek meg. Nem része: jogosultságok, lezárási okok, garanciális visszahozás, az ügyfélfiókból kért lemondás.',
    },
    {
      id: 'CH-007',
      prs: [158, 156, 147],
      date: '2026-09-23',
      area: 'Szerviz',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Szerviz alkatrész-beszerzés: összevont rendelés, beérkezés, hiány',
      summary:
        'A munkalapok alkatrészigényei márka és beszállító szerint összevont beszerzési listába kerülnek (táblázatba exportálhatóan), a beérkezés részletekben is rögzíthető, az alkatrész munkalaponként kiosztható. A hiányzó vagy sérülten érkezett tétel soronként lezárható („Lezárva — nem kerül a munkalapra”), a lezárt munkalapra érkező alkatrész visszakerül a készletbe, az igény visszavonható, a beszállítók szerkeszthetők és inaktiválhatók, a leadott rendelés ára és beszállítója pedig rögzül. A beszállítói rendelés kiküldése és a számlázás továbbra is a jelenlegi külső rendszerben marad.',
      uncertain: true,
      note: 'A leírás szerint az új beszerzési lépéseket böngészőben nem kattintották végig — Peti erősítse meg a menüpontok nevét és a lépések sorrendjét.',
    },
    {
      id: 'CH-008',
      prs: [159],
      date: '2026-09-23',
      area: 'Dolgozói felület',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Súgó gomb minden dolgozói oldalon, kereshető tudásbázissal',
      summary:
        'Minden dolgozói oldal fejlécében (iroda, pult, szerviz-pult, PDA) ott a „Súgó” gomb, amely a tudásbázis éppen ahhoz az oldalhoz tartozó részére visz: 36 témakör, számozott lépések és „Mi van, ha…” esetek. A súgó ékezet nélkül is kereshető, és mindenki csak azokat a részeket látja, amelyekhez joga van. Minden szakasz „Vázlat” jelzésű, amíg egy dolgozó át nem nézi.',
      uncertain: true,
      note: 'Döntés kell: a Súgó ugyanabban a lapban nyílik, így egy mentetlen űrlap elveszhet — maradjon így, vagy új lapon nyíljon? A tartalmat egy dolgozónak kell átnéznie (a leírás szerint kb. 3,5% hiányosság maradhatott).',
    },
    {
      id: 'CH-009',
      prs: [154],
      date: '2026-09-21',
      area: 'Bérlés',
      kind: 'Javítás',
      audience: 'ügyfél',
      title: 'Fél napos foglalásnál a választott órák megmaradnak',
      summary:
        'Fél napos vagy egy napon belüli foglalásnál az időválasztóban megadott órák (pl. 10:00–13:00) eddig nem mentődtek el a foglalásba. Most az árelőnézetben, az összesítőben és a pultnál látott foglalásban is ugyanaz az időpont szerepel, és dátum- vagy óraváltáskor csak elérhető órák választhatók. A korábban így elveszett órák utólag nem állíthatók vissza.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-010',
      prs: [156, 155, 147],
      date: '2026-09-21',
      area: 'Szerviz',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Szervizdíjak gépkategóriánként, beszállítói árak az ajánlatban',
      summary:
        'A szervizbeállításokban hat gépkategória nettó díja, sürgősségi és összeszerelési díj, valamint termékcsoportonként fix vagy sávos kiskereskedelmi és nagykereskedelmi árképzés állítható; az átvételkor választott kategória díjai rögzülnek a munkalapon, a díjak későbbi módosítása pedig a korábbi ajánlatokat nem árazza át. A beszállító által visszaigazolt nettó ár (két tizedesig), a beszállító és az árcsoport átvehető az ajánlatba, és az árat érintő munkalap-módosítás új ügyfél-jóváhagyást kér. A pult a gép megérkezése előtt visszaigazolhatja a tervezett leadást; a szerelő nem látja a belső beszerzési árakat.',
      uncertain: true,
      note: 'A tényleges díjakat a vezetőnek kell beállítania és aktiválnia (kitalált alapárak nincsenek) — Peti erősítse meg, hogy élesben megtörtént-e. A webshop árazása nem része.',
    },
    {
      id: 'CH-011',
      prs: [156, 151, 149, 147],
      date: '2026-09-21',
      area: 'Szerviz',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Műhely-ábratár: kattintható ábrák, kitöltött alkatrészkérés',
      summary:
        'A műhely ábratárában a szerelők által feltöltött ábrák mellett a meglévő gépkatalógusok is megjelennek, márka és modell szerint kereshetően, és a munkalaphoz ábra csatolható. Az ábrán a pozíciószámra kattintva kitöltődik az alkatrészkérés (több gyártói cikkszám esetén választani kell), a kérés a munkalaphoz és a pontos ábrához kapcsolódik, és később ugyanarra az ábrára nyílik vissza. A feltöltött ábrák belsők maradnak, amíg a vezető nem engedélyezi a webes megjelenésüket.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-012',
      prs: [153],
      date: '2026-09-21',
      area: 'Pult és PDA',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'PDA: PIN-es belépés, gép-QR és aláírt kiadás/visszavétel',
      summary:
        'A bérgépek kiadása és visszavétele a PDA-n történhet: a dolgozó hatjegyű PIN-kóddal lép be (öt perc tétlenség után zárol), beolvassa a gép állandó QR-kódját, és tartozéklistával ellenőrzi a gépet. Az ügyfél a PDA-n aláír, vagy a saját fiókjában fogadja el a listát egyszer használható QR-kóddal; részleges visszavételnél a hiányzó tartozék nyitva tartja a bérlést, a sérült gép irodai teendőt kap és ellenőrzésig nem adható ki. A szervizes átvétel is mehet PDA-n, egy bérgép nem lehet egyszerre bérlőnél és szervizben, és a gépekre, foglalásokra, munkalapokra QR-címke nyomtatható.',
      uncertain: true,
      note: 'A leírás szerint élesítés még nem történt, egy szerveroldali beállítás kell hozzá, és a PDA olvasóját, kameráját, az aláírást és a címkenyomtatót a boltban még ki kell próbálni — Peti erősítse meg, él-e már, és melyik eszközön tesztelhető.',
    },
    {
      id: 'CH-013',
      prs: [154, 140],
      date: '2026-09-21',
      area: 'Dolgozói felület',
      kind: 'Javítás',
      audience: 'dolgozó',
      title: 'Ügyfélkarton, ügyek és pultnapló pontosabb adatai',
      summary:
        'Az ügyfélkartonon a bérlés időszaka a pontos napot és — ha van — az átvételi és visszahozási órát mutatja (eddig tévesen hajnali 2:00 jelent meg), az idővonalon pedig minden esemény alatt látszik, melyik bérléshez tartozik. A pult „Ki mit intézett” naplója konkrétan kiírja, mi mire változott (a személyi okmány számát nem). A napi listából megnyitott kapcsolatűrlapos megkeresés üres beszélgetés helyett az eredeti üzenetet mutatja.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-014',
      prs: [145, 135, 134],
      date: '2026-09-20',
      area: 'Bérlés',
      kind: 'Javítás',
      audience: 'dolgozó',
      title: 'Bérlés-ügyeknél a foglalás valódi állapota látszik',
      summary:
        'Az ügylistán, az ügyfélkartonon és az ügyfél saját fiókjában a bérlés-ügy mellett eddig mindig „Nyitott” vagy „Feldolgozás alatt” állt; most a foglalás tényleges állapota látszik (dolgozóknak pl. Függő, Visszaigazolva, Kiadva, Lezárt, Lemondva; az ügyfélnek pl. Visszaigazolásra vár, Visszaigazolt, Gép kiadva, Gép visszavéve). Az ügylista öt bérlési állapotszűrővel szűrhető.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-015',
      prs: [146, 145, 144, 143, 142],
      date: '2026-09-20',
      area: 'Webshop',
      kind: 'Új',
      audience: 'ügyfél',
      title: 'Alkatrészábrák a gép- és termékoldalon, egyszerűbb alkatrészkereső',
      summary:
        'A bérgép és a webshoptermék adatlapjáról egy kattintással megnyitható a hozzá rendelt pontos robbantott alkatrészábra: bérgépnél a jobb oldali bérlési panel alatt, a webshopban a vásárlódoboz alatt; az ábrákat a vezető rendeli hozzá a termékszerkesztőben. Az alkatrészkeresőben gépválasztás után összecsukódik a géprács, helyette Gépváltás és alkatrészkosár gomb látszik, a kosár tartalma megmarad. A szóközös vagy ékezetes gépkódú régi alkatrészkereső-linkek már nem adnak hibaoldalt.',
      uncertain: true,
      note: 'A leírás szerint az ábrák szervizlapra öröklése egy külön ügykezelési kapcsolóhoz kötött, és akkor élesítés nem történt — Peti erősítse meg, hogy élesben aktív-e. A leírás szerint az asztali gépes nyilvános alkatrészkereső korlátozása változatlan: Peti mondja meg, ez mit jelent a látogatónak.',
    },
    {
      id: 'CH-016',
      prs: [145],
      date: '2026-09-20',
      area: 'Webshop',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Használt bérgépek eladása a webshopban',
      summary:
        'A bérgépnél bekapcsolható a használt gép hirdetése saját bruttó árral és állapotleírással, és a gép a meghirdetés után is bérelhető marad. A webshopos rendelés lefoglalja, a lemondás felszabadítja, a teljesített vagy a boltban rögzített eladás kivezeti a gépet; egy géphez egy darab tartozik, így nem adható el kétszer és nem ütközhet bérléssel. A tömeges módosítás és az Excel-import nem írja felül a használt hirdetést.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-017',
      prs: [150],
      date: '2026-09-20',
      area: 'Dolgozói felület',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Saját dolgozói szerepkörök és modulonkénti jogosultságok',
      summary:
        'A vezető saját nevű szerepköröket (titulusokat) hozhat létre modulonként megtekintési és műveleti joggal, és a dolgozói fiókokhoz szerepkört, illetve személyes engedélyt vagy tiltást rendelhet; a tiltás az erősebb. A változás a dolgozó következő kattintásánál érvényes, a menük és az oldalak ehhez igazodnak. Korlátozott jogú kezelő nem hozhat létre a sajátjánál erősebb fiókot, és az utolsó teljes jogú vezetői fiók nem zárható ki.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-018',
      prs: [141],
      date: '2026-09-19',
      area: 'Weboldal és keresők',
      kind: 'Javítás',
      audience: 'ügyfél',
      title: 'Fejléc-kereső: a Vissza gomb nem dob ki az oldalról',
      summary:
        'Ha a látogató a fejléc keresőjében keres, a böngésző Vissza gombja most csak a keresőablakot zárja be, nem viszi el az oldalról. Egy találat megnyitása után visszalépve a keresőablak ugyanazzal a keresőszóval és találatokkal nyílik újra.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-019',
      prs: [139, 133],
      date: '2026-09-19',
      area: 'Weboldal és keresők',
      kind: 'Javítás',
      audience: 'ügyfél',
      title: 'Jogi és Projektek oldal: kaució-szöveg és projekt-végdátum',
      summary:
        'Az ÁSZF és a Bérlési feltételek eddig bankkártyás előengedélyezést (zárolást) ígértek a kaucióra, amit a pulti kártyaterminál nem tud; a szöveg most bankkártyás terhelést ír. A Projektek oldalon a projekt tervezett befejezési dátuma 2026. október 31. lett (korábban május 31.). A kártyás fizetés esetleges kezelési költsége nem része ennek a változásnak.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-020',
      prs: [138, 136],
      date: '2026-09-18',
      area: 'Bérlés',
      kind: 'Új',
      audience: 'ügyfél',
      title: 'Visszaigazoló e-mail a vevőnek, amikor a pult elfogadja a foglalást',
      summary:
        'Amikor a pult visszaigazol egy függő foglalást — a foglalási táblából, a pult foglalás-oldaláról vagy az e-mailes linkről —, a vevő e-mailt kap a géppel, az időszakkal, az átvétel és a visszahozás módjával, a díjjal és a kaucióval, a foglalási azonosítóval és az átvétel helyével. Foglalásonként egyszer megy ki, és az ügyfélkarton naplójában „Ügyfélértesítés elküldve” bejegyzés jelenik meg. A weboldal eddig is ígérte ezt a levelet, de nem ment ki.',
      uncertain: true,
      note: 'Döntés kell: a pultnál felvitt, azonnal visszaigazolt bérlés jelenleg nem kap ilyen levelet — maradjon így? SMS-értesítés nincs.',
    },
    {
      id: 'CH-021',
      prs: [137],
      date: '2026-09-18',
      area: 'Dolgozói felület',
      kind: 'Új',
      audience: 'dolgozó',
      title: 'Ügyfél beolvasása QR-kóddal vagy ügyfélkóddal',
      summary:
        'Új „Ügyfél beolvasása” menüpont (és gomb a „Mai munkám” fejlécében): az ügyfél fiókjában látható QR-kódot vagy ügyfélkódot kamerával, vonalkódolvasóval vagy kézzel beolvasva egy képernyőn látszik az ügyfél, a mai átvételei és visszahozásai (a lejárt visszahozás sárgával), a nyitott ügyei és teendői, valamint a legutóbbi 5 bérlése. A pult, az iroda és a vezetők használhatják; a kamera képe nem hagyja el a böngészőt.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-022',
      prs: [131],
      date: '2026-09-15',
      area: 'Dolgozói felület',
      kind: 'Új',
      audience: 'dolgozó',
      title: '„KC Munkatér” dolgozói app; belépés után vissza a megnyitott oldalra',
      summary:
        'A dolgozók (pult, szerviz, iroda, vezetés) külön „KC Munkatér” alkalmazásként tehetik ki a dolgozói felületet a telefonjuk kezdőképernyőjére; a belépő-oldalon telepítési útmutató van. Ha egy dolgozó kijelentkezve nyit meg egy konkrét foglalást vagy oldalt, belépés után pontosan oda jut, nem a kezdőoldalra; jogosultság nélküli dolgozó végtelen átirányítás helyett érthető tájékoztató oldalt lát.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-023',
      prs: [132],
      date: '2026-09-15',
      area: 'Dolgozói felület',
      kind: 'Javítás',
      audience: 'belső',
      title: 'Biztonsági javítás: védett oldalak adatai csak belépve érhetők el',
      summary:
        'Kijavítottunk egy hibát, amelynél bejelentkezés nélkül 26 védett dolgozói oldal (pl. foglalások, beállítások, termékek) adatai a háttérben kiolvashatók voltak, bár a látogatót a rendszer a belépésre irányította. Ezek az oldalak most csak jogosult dolgozónak adnak adatot.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-024',
      prs: [130],
      date: '2026-09-15',
      area: 'Egyéb',
      kind: 'Változás',
      audience: 'ügyfél',
      title: 'Új app-ikon: a fejléc KC-logója a telefonra telepített weboldalon',
      summary:
        'A telefonra telepített Kisgépcentrum-weboldal, a böngészőfül és az értesítések ikonja a betűs „KC” monogram helyett a fejlécben is látható KC-logó lett, krémszínű háttéren. A már telepített példányok a régi ikont mutatják, amíg újra nem telepítik őket.',
      uncertain: false,
      note: '',
    },
    {
      id: 'CH-025',
      prs: [127],
      date: '2026-09-14',
      area: 'Pult és PDA',
      kind: 'Új',
      audience: 'ügyfél',
      title: 'Kioszk: érintőbillentyűzet, és pontos „mai” foglaláslista a pulton',
      summary:
        'A bolti kioszkon a gépkereső és a foglalási űrlap mezőjére koppintva érintőbillentyűzet nyílik magyar ékezetekkel, telefonszám- és e-mail-bevitellel, így fizikai billentyűzet nélkül is végig lehet foglalni (céges költségviselő adataival együtt); a foglalás bezárásakor vagy tétlenség után a be nem küldött adatok törlődnek. A pult régebbi foglaláslistájának „mai” szűrője éjfél után is a budapesti napot használja, így nem marad ki a napi foglalás.',
      uncertain: false,
      note: '',
    },
  ],
  cases: [
    {
      id: 'TC-001',
      path: '/webshop',
      change: 'CH-001',
      title: 'STIGA terméknél látszik a gyártói vonalkódszám',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal webshopját.',
      steps: [
        'Írd a webshop keresőjébe: SFC 530 AE',
        'Nyisd meg a STIGA SFC 530 AE termék adatlapját.',
        'Keresd meg a termékadatok között a vonalkódszámot (EAN) és a gyártói cikkszámot.',
        'Ismételd meg az SBT 520 AE és a CS 750 18 termékkel.',
      ],
      expected:
        'Az SFC 530 AE-nél az EAN 8008984811980, az SBT 520 AE-nél 8008984811843, a CS 750 18-nál 8008984853522. Az ár és a készletadat ugyanaz, mint a módosítás előtt.',
    },
    {
      id: 'TC-002',
      path: '/webshop',
      change: 'CH-001',
      title: 'A Ceccato SPL13R4H terméknek valódi leírása van',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal webshopját.',
      steps: [
        'Írd a webshop keresőjébe: SPL13R4H',
        'Nyisd meg a Ceccato SPL13R4H termék adatlapját.',
        'Olvasd el a termékleírást.',
      ],
      expected:
        'A leírás valódi termékismertető, nem „Feltöltés alatt...” szöveg; az ár és a többi adat változatlan.',
    },
    {
      id: 'TC-003',
      path: '/berles',
      change: 'CH-002',
      title: 'Kategóriákon át egy gépig, majd vissza',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal Bérlés oldalát (/berles), telefonon vagy számítógépen.',
      steps: [
        'Kattints egy főkategóriára.',
        'Kattints egy alkategóriára, majd ha van, még egy szinttel lejjebb.',
        'Görgess le a listában, és nyiss meg egy gépet.',
        'Nyomd meg kétszer a böngésző Vissza gombját.',
      ],
      expected:
        'Minden kategóriaszinten látszanak az alkategóriák linkjei. Visszalépéskor ugyanaz a lista jelenik meg, ugyanott, ahol a görgetésben jártál.',
    },
    {
      id: 'TC-004',
      path: '/berles',
      change: 'CH-002',
      title: 'A lapozott katalógusoldal külön címen is megnyitható',
      role: 'ügyfél (weboldal)',
      pre: 'Számítógépen nyisd meg a Bérlés oldalt, és válassz egy sok gépet tartalmazó kategóriát.',
      steps: [
        'Lapozz a lista 2. oldalára.',
        'Másold ki a böngésző címsorából a címet.',
        'Nyiss egy új böngészőfület, és illeszd be oda a címet.',
      ],
      expected: 'Az új fülön ugyanaz a 2. oldal jelenik meg ugyanazokkal a gépekkel.',
    },
    {
      id: 'TC-005',
      path: '/',
      change: 'CH-003',
      title: 'Új szöveg a felső sávban',
      role: 'ügyfél (weboldal)',
      pre: 'Telefonon és számítógépen is nyisd meg a weboldalt.',
      steps: [
        'Nézd meg a kezdőlap tetején futó sávot.',
        'Nyisd meg a Bérlés oldalt, majd egy webshoptermék oldalát, és nézd meg ott is a sávot.',
      ],
      expected:
        'Mindenhol ez áll: „Bérlési igény online, átvétel visszaigazolás után”. A „Foglalj online, vidd azonnal” szöveg sehol nem jelenik meg; a nyitvatartás továbbra is látszik.',
    },
    {
      id: 'TC-006',
      path: '/',
      change: 'CH-003',
      title: 'Google-vélemények link a kezdőlapon',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal kezdőlapját.',
      steps: [
        'Görgess le a vélemények részhez.',
        'Kattints az értékelés alatti „Vélemények a Google-on” linkre.',
      ],
      expected:
        'A Kisgépcentrum Google-profilja nyílik meg az értékelésekkel. A kezdőlapi értékelés, dátum és az idézett vélemények változatlanok.',
    },
    {
      id: 'TC-007',
      path: '/',
      change: 'CH-003',
      title: 'Talajmaró és ágdaráló közvetlen linkje',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal kezdőlapját.',
      steps: [
        'Görgess a kategóriakártyákhoz, és keresd meg alattuk az új linksort.',
        'Kattints a „Talajmaró bérlése” linkre.',
        'Lépj vissza, és kattints az „Ágdaráló bérlése” linkre.',
      ],
      expected:
        'Mindkét link a megfelelő bérlési kategóriaoldalra visz (a címe Talajmaró bérlése, illetve Ágdaráló bérlése). Az öt kategóriakártya, köztük a Kerti, változatlanul működik.',
    },
    {
      id: 'TC-008',
      change: 'CH-004',
      title: 'Régi címek a mai oldalra visznek',
      role: 'ügyfél (weboldal)',
      pre: 'Kéznél van a 11 régi oldalcím listája (Petitől).',
      steps: [
        'Írd be egyenként a régi címeket a böngésző címsorába.',
        'Minden címnél nézd meg, melyik oldal jelenik meg.',
        'Végül írj be egy kitalált, nem létező régi címet.',
      ],
      expected:
        'Mind a 11 régi cím a hozzá illő mai oldalra visz (pl. a régi kerti kategória a mai kerti bérlési kategóriára), hibaoldal nélkül. A kitalált cím továbbra is „nem található” oldalt ad.',
    },
    {
      id: 'TC-009',
      path: '/fiok',
      change: 'CH-005',
      title: 'Ajánlat elfogadása a levélből indulva',
      role: 'ügyfél (weboldal)',
      pre: 'Van egy próba-szervizügy egy általad olvasható e-mail-címmel, és a szerviz már küldött rá árajánlatot.',
      steps: [
        'Nyisd meg az ajánlat-levelet.',
        'Nézd meg az összegeket és az érvényességet.',
        'Kattints a levélben lévő linkre, és lépj be (vagy kapcsold a fiókodhoz az ügyet).',
        'Nyisd meg az ügyet, és fogadd el az ajánlatot.',
      ],
      expected:
        'A levélben látszik a teljes összeg, a befizetett rész, a még fizetendő vagy visszajáró összeg és az érvényesség óra:percre. Belépés után az ügyre jutsz, nem a kezdőlapra. Elfogadás után az ügyön az elfogadás látszik, és visszaigazoló levél érkezik.',
    },
    {
      id: 'TC-010',
      path: '/fiok',
      change: 'CH-005',
      title: 'Lejárt ajánlat',
      role: 'ügyfél (weboldal)',
      pre: 'Van egy próba-szervizügy, amelynek az ajánlata már lejárt.',
      steps: ['Lépj be a fiókodba.', 'Nyisd meg az ügyet és az ajánlatot.'],
      expected: 'Az ajánlat „Lejárt” jelzésű, és csak elutasítani lehet, elfogadni nem.',
    },
    {
      id: 'TC-011',
      path: '/szerviz',
      change: 'CH-005',
      title: 'Szervizoldal mobilon nagy betűvel',
      role: 'ügyfél (weboldal)',
      pre: 'Telefonon állítsd a betűméretet a legnagyobbra.',
      steps: [
        'Nyisd meg a weboldal Szerviz oldalát.',
        'Görgesd végig a gépleadási űrlapot és az ügykövető részt.',
      ],
      expected:
        'Minden cím, gomb, mező és jogi nyilatkozat tördelve elfér, oldalra görgetni nem kell.',
    },
    {
      id: 'TC-012',
      path: '/admin/szervizmuhely/uj',
      change: 'CH-006',
      title: 'Teljes szervizkör egy próbagéppel',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként a dolgozói felületen; van egy próbagép és egy próba-ügyfél.',
      steps: [
        'Nyisd meg a Szervizműhely menüpontot, és vegyél fel új átvételt a próbagéppel.',
        'Nyomtasd ki a szervizlapot és a QR-címkét.',
        'Szervizesként rögzíts bevizsgálást, becsült munkaidőt és egy alkatrészigényt.',
        'Rögzítsd a tényleges munkaidőt, végezd el az ellenőrzést, és állítsd a munkalapot átvehetőre.',
        'Pultosként add ki a gépet.',
      ],
      expected:
        'Végig ugyanaz a munkalap van nyitva. A szervizlap egy A4-es oldal, a QR-címke olvasható. Az „átvehető” és a „kiadva” állapot külön lépés.',
    },
    {
      id: 'TC-013',
      path: '/admin/szervizmuhely',
      change: 'CH-006',
      title: 'Díjmentes lemondás bevizsgálás előtt',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként; van egy frissen átvett próba-munkalap, még bevizsgálás nélkül.',
      steps: ['Nyisd meg a munkalapot.', 'Válaszd a lemondást, és erősítsd meg.'],
      expected: 'A munkalap díj felszámítása nélkül zárul le.',
    },
    {
      id: 'TC-014',
      path: '/admin/szervizmuhely',
      change: 'CH-006',
      title: 'Telefonos ügyfél teendője és döntésének rögzítése',
      role: 'pultos',
      pre: 'Van egy próba-munkalap, amelynek ajánlata döntésre vár, és az ügyfél telefonon tartja a kapcsolatot.',
      steps: [
        'Nyisd meg a „Mai munkám” listát, és keresd meg a „Hívd fel” teendőt.',
        'Nyisd meg a munkalapot, és rögzítsd az ügyfél telefonon közölt elfogadását.',
      ],
      expected:
        'A „Hívd fel” teendő megjelenik; a rögzítés után a munkalapon az elfogadott ajánlat látszik, a pultos árat nem módosíthat.',
    },
    {
      id: 'TC-015',
      path: '/admin/szervizmuhely/beszerzes',
      change: 'CH-007',
      title: 'Összevont beszerzési lista és részbeérkezés',
      role: 'vezető',
      pre: 'Két próba-munkalapon van alkatrészigény ugyanannál a beszállítónál, az egyiken 2 darab.',
      steps: [
        'Nyisd meg a Szervizműhely → Beszerzés oldalt.',
        'Nézd meg, hogy a két igény egy beszállítónál, összevonva szerepel-e.',
        'Exportáld a listát táblázatba.',
        'Rögzítsd, hogy a 2 darabból csak 1 érkezett meg.',
        'Oszd ki a beérkezett darabot a munkalapra.',
      ],
      expected:
        'Az igények beszállítónként összevonva látszanak, az export megnyitható. A soron 1 beérkezett és 1 hiányzó darab látszik, a munkalapon a kiosztott alkatrész megjelenik.',
    },
    {
      id: 'TC-016',
      path: '/admin/szervizmuhely/beszerzes',
      change: 'CH-007',
      title: 'Hiány lezárása',
      role: 'vezető',
      pre: 'Az előző teszt rendelésén 1 darab még hiányzik.',
      steps: ['A hiányzó soron válaszd a hiány lezárását.', 'Nyisd meg az érintett munkalapot.'],
      expected:
        'A munkalapon a lezárt tétel „Lezárva — nem kerül a munkalapra” címkével látszik. Ha egy rendelés minden sora így zárul, a rendelés címkéje „Lezárva — nem érkezett tétel”, nem „Teljesítve”.',
    },
    {
      id: 'TC-017',
      path: '/admin/sugo',
      change: 'CH-008',
      title: 'A Súgó az aktuális oldalhoz visz',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként a dolgozói felületen, nincs nyitott mentetlen űrlap.',
      steps: ['Nyisd meg a foglalások oldalát.', 'Kattints a fejlécben a „Súgó” gombra.'],
      expected:
        'A súgó a foglalásokról szóló részen nyílik meg, „Vázlat” jelzéssel, számozott lépésekkel.',
    },
    {
      id: 'TC-018',
      path: '/admin/sugo',
      change: 'CH-008',
      title: 'Keresés ékezet nélkül',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként, a Súgó oldalon.',
      steps: ['Írd a súgó keresőjébe: foglalas'],
      expected: 'A foglalásokkal kapcsolatos témakörök megjelennek, ugyanúgy, mint ékezettel írva.',
    },
    {
      id: 'TC-019',
      path: '/admin/sugo',
      change: 'CH-008',
      title: 'Csak a jogosult témakörök látszanak',
      role: 'szervizes',
      pre: 'Bejelentkezve egy olyan szervizes fiókkal, amelynek nincs joga a beállításokhoz.',
      steps: ['Kattints a „Súgó” gombra, majd nyisd meg a súgó tartalomjegyzékét.'],
      expected:
        'A beállításokról szóló súgórész nem jelenik meg; a szervizes munkához tartozó részek igen.',
    },
    {
      id: 'TC-020',
      path: '/berles',
      change: 'CH-009',
      title: 'Fél napos próbafoglalás órákkal',
      role: 'ügyfél (weboldal)',
      pre: 'A weboldalon nyiss meg egy fél napra is bérelhető gépet (a próbafoglalást utána a pult lemondja).',
      steps: [
        'Válassz egy napot és fél napos bérlést.',
        'Állítsd be: 10:00–13:00.',
        'Nézd meg az árelőnézetet és az összesítőt.',
        'Küldd el a foglalást.',
      ],
      expected:
        'Az árelőnézetben és az összesítőben 10:00–13:00 szerepel, a foglalás hiba nélkül elküldhető.',
    },
    {
      id: 'TC-021',
      path: '/pult',
      change: 'CH-009',
      title: 'A pult ugyanazokat az órákat látja',
      role: 'pultos',
      pre: 'Az előző teszt próbafoglalása beérkezett.',
      steps: ['Nyisd meg a pulton a próbafoglalást.'],
      expected: 'A foglaláson ugyanaz a nap és 10:00–13:00 időpont látszik.',
    },
    {
      id: 'TC-022',
      path: '/admin/szervizmuhely/beallitasok',
      change: 'CH-010',
      title: 'Kategóriás díjszabás beállítása',
      role: 'vezető',
      pre: 'Bejelentkezve vezetőként; a díjakat egyeztetted.',
      steps: [
        'Nyisd meg a Szervizműhely → Beállítások oldalt.',
        'Kattints a „Kategóriás díjszabás előkészítése” gombra.',
        'Add meg a hat gépkategória díját, a sürgősségi és az összeszerelési díjat.',
        'Kattints a „Díjszabás mentése” gombra.',
      ],
      expected: 'A díjak elmentődnek, a korábbi beállítások nem vesznek el.',
    },
    {
      id: 'TC-023',
      path: '/admin/szervizmuhely',
      change: 'CH-010',
      title: 'Régi ajánlat nem árazódik át',
      role: 'vezető',
      pre: 'Van egy próba-munkalap kész ajánlattal.',
      steps: [
        'Emeld meg az egyik kategória díját a beállításokban, és mentsd.',
        'Nyisd meg újra a próba-munkalap ajánlatát.',
      ],
      expected:
        'A meglévő ajánlat összege nem változott; az új díj csak az új átvételekre vonatkozik.',
    },
    {
      id: 'TC-024',
      path: '/admin/szervizmuhely',
      change: 'CH-010',
      title: 'A szerelő nem lát beszerzési árat',
      role: 'szervizes',
      pre: 'Bejelentkezve szervizesként; van egy munkalap beszállítói árral visszaigazolt alkatrésszel.',
      steps: ['Nyisd meg a munkalapot és az alkatrészeket.'],
      expected: 'A belső beszerzési ár és a beszállítói visszaigazolás adatai nem látszanak.',
    },
    {
      id: 'TC-025',
      path: '/admin/szervizmuhely/abrak',
      change: 'CH-011',
      title: 'Alkatrészkérés kattintással az ábráról',
      role: 'szervizes',
      pre: 'Bejelentkezve szervizesként; van egy nyitott próba-munkalap olyan géppel, amelyhez van katalógus.',
      steps: [
        'Nyisd meg a munkalapot, majd az alkatrészkérést / ábrákat.',
        'Keresd ki a gép katalógusát márka vagy modell szerint, és nyisd meg a megfelelő ábrát.',
        'Kattints egy pozíciószámra az ábrán.',
        'Ha több cikkszám jelenik meg, válassz egyet; hagyd a mennyiséget 1-en, és küldd be.',
      ],
      expected:
        'Az űrlap automatikusan kitöltődik; a beküldött kérés megjelenik a munkalapon, és megnyitva ugyanarra az ábrára visz. A webshop kosara nem változik.',
    },
    {
      id: 'TC-026',
      path: '/admin/szervizmuhely/abrak',
      change: 'CH-011',
      title: 'Feltöltött ábra jóváhagyása',
      role: 'vezető',
      pre: 'Bejelentkezve vezetőként; kéznél egy próbaábra fájl.',
      steps: [
        'Nyisd meg a Szervizműhely → Ábrák oldalt, és tölts fel egy ábrát egy géptípushoz.',
        'Ellenőrizd, hogy a weboldalon még nem látszik.',
        'Engedélyezd a webes megjelenést, majd vond vissza.',
      ],
      expected:
        'Feltöltés után az ábra csak belül látszik; engedélyezés után megjelenik a weben, visszavonás után újra eltűnik.',
    },
    {
      id: 'TC-027',
      path: '/pda',
      change: 'CH-012',
      title: 'PIN kiosztása és PDA párosítása',
      role: 'vezető',
      pre: 'Bejelentkezve vezetőként; kéznél a bolti PDA.',
      steps: [
        'Nyisd meg a dolgozói fiókokat, és adj hatjegyű PIN-t egy próba-pultosnak.',
        'Párosítsd a PDA-t a dolgozói felületről.',
      ],
      expected: 'A PIN kiosztva, a PDA a párosított eszközök között látszik, és visszavonható.',
    },
    {
      id: 'TC-028',
      path: '/pda',
      change: 'CH-012',
      title: 'Belépés PIN-nel és automatikus zárolás',
      role: 'pultos',
      pre: 'A PDA párosítva, a pultos kapott PIN-t.',
      steps: ['Lépj be a PDA-n a PIN-nel.', 'Hagyd a PDA-t 5 percig érintés nélkül.'],
      expected:
        'A belépés sikerül, és csak a pultos jogainak megfelelő menük látszanak; 5 perc után a PDA zárol és újra PIN-t kér.',
    },
    {
      id: 'TC-029',
      path: '/pda/rentals',
      change: 'CH-012',
      title: 'Kiadás és részleges visszavétel',
      role: 'pultos',
      pre: 'Van egy visszaigazolt próbafoglalás QR-címkés géppel és tartozékokkal.',
      steps: [
        'A PDA-n nyisd meg a foglalást, és olvasd be a gép QR-kódját.',
        'Pipáld végig a tartozékokat, majd írasd alá az ügyfelet a PDA-n.',
        'Később indíts visszavételt, és jelölj egy tartozékot hiányzónak.',
      ],
      expected:
        'A kiadás után bizonylat készül, a foglalás „Kiadva”. A hiányzó tartozék miatt a bérlés nyitva marad.',
    },
    {
      id: 'TC-030',
      path: '/admin/customers',
      change: 'CH-013',
      title: 'Bérlés időszaka és idővonal az ügyfélkartonon',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként; van egy próba-ügyfél két bérléssel.',
      steps: [
        'Nyisd meg az ügyfél kartonját.',
        'Nézd meg a bérlés-ügyek időszakát.',
        'Görgesd végig az idővonalat.',
      ],
      expected:
        'Az időszak napra pontos, átvételi/visszahozási órával, sehol nincs 2:00. Az idővonal minden eseménye alatt látszik a gép és az időszak.',
    },
    {
      id: 'TC-031',
      path: '/pult',
      change: 'CH-013',
      title: 'Konkrét változások a pultnaplóban',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként; van egy próbafoglalás.',
      steps: [
        'Módosítsd a próbafoglalás visszahozási dátumát, és mentsd.',
        'Nyisd meg a „Ki mit intézett” naplót.',
      ],
      expected: 'A naplóban a változás konkrétan látszik (régi érték → új érték).',
    },
    {
      id: 'TC-032',
      path: '/admin/ugyek',
      change: 'CH-013',
      title: 'Kapcsolatűrlapos megkeresés megnyitása',
      role: 'vezető',
      pre: 'A weboldal Kapcsolat űrlapján küldtél egy próbaüzenetet.',
      steps: ['Nyisd meg a „Mai munkám” listát.', 'Kattints a próbamegkeresésre.'],
      expected:
        'Az eredeti üzenet olvasható nézete nyílik meg, nem üres beszélgetés és nem az általános ügylista.',
    },
    {
      id: 'TC-033',
      path: '/admin/ugyek',
      change: 'CH-014',
      title: 'Visszaigazolt foglalás címkéje és szűrése',
      role: 'pultos',
      pre: 'Bejelentkezve pultosként; van egy függő próbafoglalás.',
      steps: [
        'Igazold vissza a próbafoglalást.',
        'Nyisd meg az ügyfél kartonját, és nézd meg a bérlés-ügy címkéjét.',
        'Nyisd meg az ügylistát, és szűrj a visszaigazolt bérlésekre.',
      ],
      expected:
        'A kartonon és az ügylistán „Visszaigazolva” áll, nem „Nyitott”; a szűrő után a próbafoglalás ügye megjelenik.',
    },
    {
      id: 'TC-034',
      path: '/fiok',
      change: 'CH-014',
      title: 'Az ügyfél fiókjában is a valódi állapot látszik',
      role: 'ügyfél (weboldal)',
      pre: 'Az előző teszt próba-ügyfelének fiókjával bejelentkezve.',
      steps: ['Nyisd meg az ügyeid listáját, majd a bérlés-ügyet.'],
      expected: 'A listán és az ügy oldalán „Visszaigazolt” áll, nem „Feldolgozás alatt”.',
    },
    {
      id: 'TC-035',
      path: '/admin/parts-explorer',
      change: 'CH-015',
      title: 'Ábra hozzárendelése bérgéphez',
      role: 'vezető',
      pre: 'Bejelentkezve vezetőként.',
      steps: [
        'Nyiss meg egy bérgépet a termékszerkesztőben.',
        'A robbantott ábra panelen keresd meg és válaszd ki a gép pontos ábráját, nézd meg az előnézetet.',
        'Mentsd.',
      ],
      expected: 'A hozzárendelés elmentődik, és a panelen látszik.',
    },
    {
      id: 'TC-036',
      path: '/berles',
      change: 'CH-015',
      title: 'Ábra megnyitása a gép adatlapjáról',
      role: 'ügyfél (weboldal)',
      pre: 'Az előző tesztben ábrát kapott bérgép.',
      steps: [
        'Számítógépen nyisd meg a gép adatlapját a weboldalon.',
        'Keresd meg az ábrakártyát a jobb oldali bérlési panel alatt, és kattints rá.',
        'Nyiss meg egy ábrás webshoptermék adatlapját is, és nézd meg a vásárlódoboz alatt.',
      ],
      expected:
        'Az ábrakártya a bérlési panel alatt van, kattintásra a pontos ábra nyílik meg; a webshopban a vásárlódoboz alatt van.',
    },
    {
      id: 'TC-037',
      path: '/alkatresz-kereso',
      change: 'CH-015',
      title: 'Gépváltás az alkatrészkeresőben, kosár megmarad',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal alkatrészkeresőjét.',
      steps: [
        'Válassz egy gépet, és tegyél egy alkatrészt a kosárba.',
        'Kattints a Gépváltás gombra, válassz másik gépet, és tegyél onnan is egy alkatrészt a kosárba.',
        'Nyisd meg az alkatrészkosarat.',
      ],
      expected:
        'Gépválasztás után a géprács összecsukódik, és Gépváltás meg kosár gomb látszik. A kosárban mindkét alkatrész benne van a helyes mennyiséggel.',
    },
    {
      id: 'TC-038',
      change: 'CH-016',
      title: 'Használt gép meghirdetése',
      role: 'vezető',
      pre: 'Bejelentkezve vezetőként; kiválasztottál egy próba-bérgépet.',
      steps: [
        'Nyisd meg a bérgépet a dolgozói felületen.',
        'Kapcsold be a használt eladást, adj meg bruttó árat és állapotleírást, mentsd.',
        'Nézd meg a gépet a webshopban, majd a bérlési oldalán.',
      ],
      expected:
        'A webshopban a gép a megadott árral és leírással, 1 darabbal jelenik meg; a bérlési oldalán továbbra is foglalható.',
    },
    {
      id: 'TC-039',
      path: '/webshop',
      change: 'CH-016',
      title: 'Nem rendelhető kétszer',
      role: 'ügyfél (weboldal)',
      pre: 'Az előző tesztben meghirdetett használt gép.',
      steps: ['Tedd a gépet a webshop kosarába.', 'Próbáld a mennyiséget 2-re növelni.'],
      expected: 'A mennyiség nem növelhető 1 fölé.',
    },
    {
      id: 'TC-040',
      path: '/admin/jogosultsagok',
      change: 'CH-017',
      title: 'Csak megtekintési jogú szerepkör',
      role: 'vezető',
      pre: 'Bejelentkezve vezetőként; van egy próba-dolgozói fiók.',
      steps: [
        'Hozz létre egy „Teszt – csak megtekintés” szerepkört, amely a foglalásokat csak megtekintheti.',
        'Rendeld a próbafiókhoz.',
        'Lépj be a próbafiókkal, és nyisd meg a foglalásokat.',
      ],
      expected:
        'A foglalások láthatók, de módosító gombok nincsenek; a menüben csak a jogosult modulok jelennek meg.',
    },
    {
      id: 'TC-041',
      path: '/admin/jogosultsagok',
      change: 'CH-017',
      title: 'A személyes tiltás erősebb a szerepkörnél',
      role: 'vezető',
      pre: 'Az előző teszt próbafiókja belépve marad egy másik böngészőben.',
      steps: [
        'A próbafiókra tegyél személyes tiltást a foglalások modulra.',
        'A próbafiók böngészőjében kattints bárhová a foglalásokon.',
      ],
      expected: 'A következő kattintásnál a foglalások már nem érhetők el, újrabelépés nélkül.',
    },
    {
      id: 'TC-042',
      path: '/berles',
      change: 'CH-018',
      title: 'Vissza gomb nyitott keresőablakkal',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal Bérlés oldalát (/berles).',
      steps: [
        'Nyisd meg a fejléc keresőjét, és írd be: tűvibrátor',
        'Nyomd meg a böngésző Vissza gombját.',
      ],
      expected: 'A keresőablak bezárul, a Bérlés oldal marad.',
    },
    {
      id: 'TC-043',
      path: '/berles',
      change: 'CH-018',
      title: 'Visszatérés a találatokhoz',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal Bérlés oldalát.',
      steps: [
        'Keress rá a fejlécben: tűvibrátor',
        'Kattints az egyik találatra.',
        'Nyomd meg a Vissza gombot.',
        'Zárd be a keresőablakot az X-szel.',
      ],
      expected:
        'Visszalépéskor a keresőablak a „tűvibrátor” szóval és ugyanazokkal a találatokkal nyílik újra; az X után a sima oldal marad.',
    },
    {
      id: 'TC-044',
      path: '/jogi',
      change: 'CH-019',
      title: 'Kaució-szöveg a jogi oldalon',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal Jogi oldalát (/jogi).',
      steps: [
        'Az ÁSZF fülön keresd meg a kaucióról szóló részt (6.1. pont).',
        'A Bérlési feltételek fülön is keresd meg a kaucióról szóló részt (4. pont).',
      ],
      expected:
        'Mindkét helyen bankkártyás terhelés szerepel, az „előengedélyezés” szó sehol nem fordul elő.',
    },
    {
      id: 'TC-045',
      path: '/projektek',
      change: 'CH-019',
      title: 'Projekt-végdátum',
      role: 'ügyfél (weboldal)',
      pre: 'Nyisd meg a weboldal Projektek oldalát (/projektek).',
      steps: ['Keresd meg a „Projekt tervezett befejezési dátuma” sort.'],
      expected: 'A dátum: 2026. október 31.',
    },
    {
      id: 'TC-046',
      path: '/pult',
      change: 'CH-020',
      title: 'Visszaigazolás a pult foglalás-oldaláról',
      role: 'pultos',
      pre: 'A weboldalon leadtál egy próbafoglalást egy általad olvasható e-mail-címmel; a foglalás függő.',
      steps: [
        'Nyisd meg a próbafoglalást a pulton.',
        'Kattints a visszaigazolásra.',
        'Nézd meg a postafiókot.',
        'Nyisd meg az ügyfél kartonját, és nézd meg a naplót.',
      ],
      expected:
        'Néhány percen belül megérkezik a visszaigazoló levél a gép, az időszak, a díj és a kaució külön, a foglalási azonosító és az átvétel helye adataival. A kartonon „Ügyfélértesítés elküldve” bejegyzés áll.',
    },
    {
      id: 'TC-047',
      path: '/admin/bookings',
      change: 'CH-020',
      title: 'Visszaigazolás a foglalási táblából',
      role: 'vezető',
      pre: 'Van egy második függő próbafoglalás saját e-mail-címmel.',
      steps: [
        'Nyisd meg a foglalások tábláját.',
        'Kattints a próbafoglalás „Visszaigazol” gombjára.',
        'Nézd meg a postafiókot.',
      ],
      expected: 'Egy darab visszaigazoló levél érkezik.',
    },
    {
      id: 'TC-048',
      path: '/admin/beolvasas',
      change: 'CH-021',
      title: 'QR-kód beolvasása kamerával',
      role: 'pultos',
      pre: 'Van egy próba-ügyfél ügyfélfiókkal és egy mára szóló visszaigazolt foglalással; az ügyfél telefonján nyitva a fiókja a QR-kóddal.',
      steps: [
        'A dolgozói felületen nyisd meg az „Ügyfél beolvasása” menüpontot.',
        'Engedélyezd a kamerát, és olvasd be az ügyfél QR-kódját.',
      ],
      expected:
        'Megjelenik az ügyfél, a „Ma: átvétel” részben a mai foglalása, valamint a nyitott ügyei és az utolsó bérlései.',
    },
    {
      id: 'TC-049',
      path: '/admin/beolvasas',
      change: 'CH-021',
      title: 'Ügyfélkód kézi beírása',
      role: 'pultos',
      pre: 'Az előző teszt próba-ügyfelének ügyfélkódja (a fiókjában látható).',
      steps: [
        'Az „Ügyfél beolvasása” oldalon írd be kézzel a kódot kisbetűvel, szóközök és kötőjelek nélkül.',
        'Nyomj Entert.',
      ],
      expected: 'Ugyanaz az ügyfél és ugyanazok a mai tételek jelennek meg.',
    },
    {
      id: 'TC-050',
      path: '/pult/login',
      change: 'CH-022',
      title: 'KC Munkatér telepítése telefonra',
      role: 'pultos',
      pre: 'Telefonon, kijelentkezve.',
      steps: [
        'Nyisd meg a pult belépő-oldalát.',
        'Kövesd a telepítési útmutatót, és tedd ki az appot a kezdőképernyőre.',
        'Indítsd el az appot a kezdőképernyőről, és lépj be.',
      ],
      expected:
        'Az app „KC Munkatér” néven jelenik meg, és belépés után a „Mai munkám” oldal nyílik.',
    },
    {
      id: 'TC-051',
      path: '/pult/login',
      change: 'CH-022',
      title: 'Belépés után vissza a konkrét foglalásra',
      role: 'pultos',
      pre: 'Kéznél egy konkrét foglalás dolgozói linkje; kijelentkezve.',
      steps: ['Nyisd meg a linket.', 'Lépj be a megjelenő belépő-oldalon.'],
      expected: 'Belépés után közvetlenül az adott foglalás oldala nyílik meg.',
    },
    {
      id: 'TC-052',
      path: '/',
      change: 'CH-024',
      title: 'Ikon a kezdőképernyőn',
      role: 'ügyfél (weboldal)',
      pre: 'Telefonon; ha korábban már kitetted a weboldalt a kezdőképernyőre, előbb töröld.',
      steps: [
        'Nyisd meg a weboldalt a telefon böngészőjében.',
        'Add hozzá a kezdőképernyőhöz.',
        'Nézd meg az ikont, és a számítógépes böngészőfül ikonját is.',
      ],
      expected:
        'Az ikon a fejléc KC-logója krémszínű háttéren, nem a betűs „KC” monogram, és a széle nincs levágva.',
    },
    {
      id: 'TC-053',
      path: '/kiosk',
      change: 'CH-025',
      title: 'Foglalás érintőbillentyűzettel',
      role: 'ügyfél (weboldal)',
      pre: 'A boltban, a kioszkon (fizikai billentyűzet nélkül).',
      steps: [
        'Koppints a gépkereső mezőre, és írd be: tűvibrátor',
        'Nyiss meg egy gépet, és indíts foglalást.',
        'Töltsd ki a nevet ékezetes betűkkel, a telefonszámot és az e-mail-címet az érintőbillentyűzettel.',
        'Koppints a „Kész” gombra, majd zárd be a foglalást elküldés nélkül, és nyisd meg újra.',
      ],
      expected:
        'Minden mezőre koppintva megnyílik a billentyűzet, az ékezetek beírhatók, a szerkesztett mező görgetéskor is látszik. A „Kész” után a beírt szöveg megmarad; a foglalás bezárása után újranyitva az űrlap üres.',
    },
    {
      id: 'TC-054',
      path: '/kiosk',
      change: 'CH-025',
      title: 'Tétlenség után törlődnek az adatok',
      role: 'ügyfél (weboldal)',
      pre: 'A kioszkon egy félig kitöltött foglalási űrlap.',
      steps: ['Hagyd a kioszkot néhány percig érintés nélkül.', 'Nézd meg a képernyőt.'],
      expected: 'A kioszk visszaáll a kezdőállapotba, a félig kitöltött adatok eltűntek.',
    },
  ],
};
